var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp"},[_c('div',{ref:"echarts",staticClass:"echarts",staticStyle:{"width":"100%","height":"350px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }